import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { ToastContext, RequestLoader } from "../../../hooks/context";
import {
  addSettlementAccount,
  resolveSettlementAccountNumber,
  getSettlementBankList,
  // getAvailableSubaccounts,
} from "../../../services/settlements";
import SettlementsLogic from "../../../pages/appPages/Settings/Settlements/SettlementsLogic";
import { useSelector } from "react-redux";

const AddSettlementAccountLogic = (
  setIsOpen,
  handleFetchSettlementAccounts,
) => {
  const [bank, setBank] = useState("");
  const [bankList, setBankList] = useState([]);
  const [account_number, setAccountNumber] = useState("");
  const [is_primary, setIsPrimary] = useState(false);
  const [isAddingAccount, setIsAddingAccount] = useState(false);
  const [isResolvingAccount, setIsResolvingAccount] = useState(false);
  const [isFetchingBankList, setIsFetchingBankList] = useState(false);
  const [isValidAccountNumber, setIsValidAccountNumber] = useState(false);
  const [accountDetails, setAccountDetails] = useState(null);
  const [businessId, setBusinessId] = useState(null);
  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const { handleSettlementType } = SettlementsLogic();
  const { business_list } = useSelector(
    (state) => state.profileDetailsReducer.profileDetails,
  );

  useEffect(() => {
    if (businessId) fetchBankList();
  }, [businessId]);

  const handleResolveAccountNumber = (account_number, bank_code) => {
    setIsResolvingAccount(true);
    resolveSettlementAccountNumber({ account_number, bank_code }, businessId)
      .then((response) => {
        setIsValidAccountNumber(true);
        setIsResolvingAccount(false);
        setAccountDetails(response.data.data);
        window.clearAccountErrors("account_number");
      })
      .catch((error) => {
        setIsResolvingAccount(false);
      });
  };

  const handleAddSettlementAccount = () => {
    setIsAddingAccount(true);
    setRequestLoaderProgress(40);

    addSettlementAccount({
      currency: business_list?.find(
        (business) => `${business?.id}` === `${businessId}`,
      )?.currency_code,
      bank_code: bank,
      nuban: account_number,
      is_primary,
      business_id: businessId,
    })
      .then(() => {
        handleSettlementType("bank_account");
        setIsAddingAccount(false);
        setRequestLoaderProgress(100);
        handleFetchSettlementAccounts();
        setIsOpen(false);
        triggerToast("Account added successfully", "success");
      })
      .catch((error) => {
        setIsAddingAccount(false);
        setRequestLoaderProgress(100);
      });
  };

  const fetchBankList = () => {
    setIsFetchingBankList(true);
    setRequestLoaderProgress(40);

    getSettlementBankList(businessId)
      .then((response) => {
        setIsFetchingBankList(false);
        setRequestLoaderProgress(100);
        setBankList(response.data?.data);
      })
      .catch((error) => {
        setIsFetchingBankList(false);
        setRequestLoaderProgress(100);
      });
  };

  // const fetchAvailableSubaccounts = () => {
  //   setRequestLoaderProgress(40);

  //   getAvailableSubaccounts()
  //     .then((response) => {
  //       setRequestLoaderProgress(100);
  //       setBusinessList(response?.data?.data);
  //     })
  //     .catch((error) => {
  //       setRequestLoaderProgress(100);
  //     });
  // };

  return {
    bank,
    account_number,
    is_primary,
    isAddingAccount,
    isResolvingAccount,
    isFetchingBankList,
    bankList,
    accountDetails,
    isValidAccountNumber,
    businessId,
    business_list,
    setBusinessId,
    setIsPrimary,
    setAccountNumber,
    setBank,
    handleAddSettlementAccount,
    handleResolveAccountNumber,
  };
};

export default AddSettlementAccountLogic;
